import globalMessage from "@/utils/globalMessage";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Banner, Navigation, ProfilePage } from './Profile.styles.js';
import Container from "@components/Container/Container.js";
import login from '@assets/images/login.jpg';
import { Button, Card, Tabs } from "antd";
import _ from "lodash";

import { api } from "@redux/api";
import { UnlockOutlined } from "@ant-design/icons";
import UserProfileForm from './UserProfileForm.js';

const { TabPane } = Tabs;

class Profile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
        }
    }

    componentDidMount() {
        let columns = [
            {
                title: 'Id',
                dataIndex: 'id',
                width: '10%',
            },
            {
                title: 'Username',
                dataIndex: 'username',
                width: '10%',
                editable: true,
            },
        ]
        this.setState({
            columns
        })
    }

    handleResetPassword = (e) => {

        let email = _.get(this.props.auth, 'email')

        this.setState({
            isLoading: true
        })
        api.forgetpassword(email).then(res => {
            this.setState({
                isLoading: false
            })
            return globalMessage['success']({
                message: 'Success',
                description: "If an account matches this email, a password reset link will be sent. Check your inbox and spam folder.", placement: 'topLeft'
            });
        }).catch(() => {
            globalMessage.error("Unable to request a password reset. Check your connection and try again.");
        }).finally(() => {
            this.setState({ isLoading: false });
        });

    }

    render() {

        return (
            <ProfilePage>
                <Banner
                    className="profile-banner"
                    style={{ backgroundImage: `url(${login})` }}
                >
                    <Container className="container">
                    </Container>
                </Banner>

                <Navigation className="navigation">
                    <Container className="profile-container">
                        <Tabs defaultActiveKey="1" centered>
                            <TabPane tab="Personal Settings" key="1">
                                <Card
                                    bordered={false}
                                    className="profile-card"
                                    title={
                                        <div className="profile-card-actions">
                                            <Button
                                                type='primary'
                                                key="1"
                                                onClick={this.handleResetPassword}
                                                loading={this.state.isLoading}
                                                disabled={this.state.isLoading}
                                                icon={<UnlockOutlined />}
                                                className="profile-reset-button"
                                            >
                                                Reset Password
                                            </Button>
                                        </div>
                                    }
                                >
                                        <UserProfileForm />
                                </Card>
                            </TabPane>
                        </Tabs>
                    </Container>
                </Navigation>
            </ProfilePage>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.Auth,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Profile);
